import styled, { css } from 'styled-components';

// Theme-aware button component
export const Button = styled.button`
  cursor: pointer;
  min-width: 10rem;
  padding: 1rem;
  text-align: center;
  transition: 0.2s ease;

  /* Use theme properties if available, fallback to default styles */
  ${({ theme }) => theme.name !== 'blank' && css`
    background: ${theme.button.background || '#f8f9fa'};
    color: ${theme.colors.text || 'inherit'};
  `}

  &:focus {
    outline: none;
  }

  &:hover {
    ${({ theme }) => theme.name !== 'blank' && css`
      text-decoration: ${theme.button.hover.textDecoration || 'underline'};
      border: ${theme.button.hover.border || '1px black solid'};
    `}
  }

  + button {
    margin-left: 1rem;
  }

  ${({ variant, theme }) =>
    variant === 'warn' && theme.name !== 'blank' &&
    css`background: ${theme.colors.red || 'var(--color-red)'};`
  }

  &:disabled {
    cursor: default;
    ${({ theme }) => theme.name !== 'blank' && css`
      background: ${theme.button.disabled.background || '#eee'};
      color: ${theme.button.disabled.color || '#ccc'};
      opacity: ${theme.button.disabled.opacity || '0.5'};
    `}
  }
`;

export const TextButton = styled.button`
  padding: 0;
  border: 0;
  font-weight: 700;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${({ truncated }) => truncated && css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  `}

  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    padding: ${theme.textButton?.padding || '0'};
    border: ${theme.textButton?.border || '0'};
    font-weight: ${theme.textButton?.fontWeight || '700'};
  `}

  &:hover {
    ${({ theme }) => theme.name !== 'blank' && css`
      text-decoration: ${theme.textButton?.hover?.textDecoration || 'underline'};
    `}
  }
`;

export default Button;
